import { IdentificationInfo, SetAqariVerfiedModel, setFingurePrintReference } from './../../shared/Models/OldWekalaModel';
import { ClauseResponse } from '@/components/AttorneyRegistration/Component/Models/ClauseResponse';
import {
  FirstParty,
  SecondParty,
} from './../../shared/Models/OldBemogabWekalaResponse';
import { ClausesGroup } from './../../components/AttorneyRegistration/Component/Models/ClausesGroup';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';

import {
  SecondPartyList,
} from '../../shared/components/ClientInfo/Models/OldWekalaModel';
import {
  OldWekalaModel,
  FirstPartyList,
  TextsValuesList,
  OtpVerification,
  PartySefa,
} from '../../shared/Models/OldWekalaModel';
import { ClausesResponse } from '@/components/AttorneyRegistration/Component/Models/ClausesResponse';
import { OldApiDateDate } from '@/models/SubWekalaDetailModel';

//@Module({ namespaced: true })
@Module({})
export default class OldWekalaStore extends VuexModule {
  oldWekalaModel: OldWekalaModel = {} as OldWekalaModel;
  bemogabWekalaClausesFlaten: ClauseResponse[] = [];
  partySefa: PartySefa = {} as PartySefa;
  //isMowakelChanged: boolean = false;

  bemogabwekalaClauses: ClausesResponse = {} as ClausesResponse;
  bemogabwekalaFirstParty: FirstParty[] = [];
  bemogabwekalaSecondParty: SecondParty[] = [];

  SuccessAttorneyCode: string = '';

  get getWekalaModel(): OldWekalaModel {
    return this.oldWekalaModel;
  }

  get getSuccessAttorneyCode(): string {
    return this.SuccessAttorneyCode;
  }


  get getBemogabWekalaFirstParty(): FirstParty[] {
    return this.bemogabwekalaFirstParty;
  }

  get getBemogabWekalaSecondParty(): SecondParty[] {
    return this.bemogabwekalaSecondParty;
  }

  get getWekalaClauses(): TextsValuesList[] {
    return this.oldWekalaModel.TextsValuesList;
  }



  get getOriginalBemogabWekalaFlatenClauses(): ClauseResponse[] {
    return this.bemogabWekalaClausesFlaten;
  }





  // get getIsAqariVerifiedFromStore(): number[] {
  //   let ret = true;
  //   let invalidGroups: number[] = [];

  //   this.selectedClauses.forEach((cls) => {
  //     let reqChilds = cls.clauses.filter(
  //       (c) =>
  //         c.verifyByAPI &&
  //         c.isAqariVerfyied == false &&
  //         c.isHiddenWhenNoValue == false
  //     );

  //     if (this.getIsPartialProhipted) {
  //       reqChilds = reqChilds.filter((c) => c.isProhibited == false);
  //     }

  //     if (reqChilds && reqChilds.length > 0) {
  //       reqChilds.forEach((ch) => {
  //         ret = false;
  //         invalidGroups.push(ch.attorneyTypeID);
  //       });
  //     }
  //   });
  //   return invalidGroups;
  // }

  get getIsPartialProhipted(): boolean {
    let prohiptedMowakel: FirstPartyList[] = [];
    let prohiptedWakel: SecondPartyList[] = [];
    if (
      this.oldWekalaModel.FirstPartyList &&
      this.oldWekalaModel.FirstPartyList.length > 0
    ) {
      prohiptedMowakel = this.oldWekalaModel.FirstPartyList.filter(
        (mowakel) => mowakel.IsPartialProhibited === true
      );
    }
    if (
      this.oldWekalaModel.SecondPartyList &&
      this.oldWekalaModel.SecondPartyList.length > 0
    ) {
      prohiptedWakel = this.oldWekalaModel.SecondPartyList.filter(
        (wakel) => wakel.IsPartialProhibited === true
      );
    }
    return prohiptedMowakel.length > 0 || prohiptedWakel.length > 0;
  }

  get getPartySefa(): PartySefa {
    return this.partySefa;
  }

  @Mutation
  public setMowkel(mowkel: FirstPartyList[]): void {
    // // debugger;
    this.oldWekalaModel.FirstPartyList = mowkel;
  }

  // @Mutation
  // public setAqariVerfiedMut(model: SetAqariVerfiedModel): void {
  //   // // debugger;
  //   let clause = this.selectedClauses.find((s) => s.id === model.clauseId);
  //   if (clause) {
  //     clause.isAqariVerfyied = model.value;
  //   }
  // }

  @Mutation
  public AddMowkelMut(mowkel: FirstPartyList): void {
    // // debugger;
    this.oldWekalaModel.FirstPartyList.push(mowkel);
  }

  @Mutation
  public removeMowkelMut(mowkel: FirstPartyList): void {
    // let index = this.oldWekalaModel.FirstPartyList.findIndex(
    //   (cls) => cls.PartyPerson.IdentityNo === mowkel.PartyPerson.IdentityNo
    // );
    let index = this.oldWekalaModel.FirstPartyList.findIndex(
      (cls) => cls.clientSideId === mowkel.clientSideId
    );

    if (index > -1) {
      this.oldWekalaModel.FirstPartyList.splice(index, 1);
    }
  }

  @Mutation
  public setSuccessAttorneyCodeMut(code: string): void {
    this.SuccessAttorneyCode = code;
  }

  @Mutation
  public setbemogabwekalaFirstPartyMut(mowkel: FirstParty[]): void {
    this.bemogabwekalaFirstParty = mowkel;
  }

  @Mutation
  public setbemogabwekalaSecondPartyMut(wakel: SecondParty[]): void {
    this.bemogabwekalaSecondParty = wakel;
  }

  @Mutation
  public clearWekala(): void {
    this.oldWekalaModel = {} as OldWekalaModel;
    // this.selectedGroups = [];
    // this.selectedClauses = [];
  }





  @Mutation
  public OriginalBemogabWekalaFlatenClausesMut(item: ClauseResponse[]): void {
    //this.selectedClauses = [];
    this.bemogabWekalaClausesFlaten = item;
  }






  @Mutation
  public setWakeelList(WakeelList: SecondPartyList[]): void {
    this.oldWekalaModel.SecondPartyList = WakeelList;
  }
  @Mutation
  public setIsGrouped(isGrouped: boolean): void {
    this.oldWekalaModel.IsSecondPartiesTogether = isGrouped;
  }

  @Mutation
  public setClauses(clauses: TextsValuesList[]): void {
    this.oldWekalaModel.TextsValuesList = clauses;
  }
  @Mutation
  public setLoginUserSocialID(loginUserSocialID: string): void {
    this.oldWekalaModel.LoginUserSocialID = loginUserSocialID;
  }
  @Mutation
  public setOperationType(operationType: number): void {
    this.oldWekalaModel.OperationType = operationType;
  }
  @Mutation
  public setAttorneyTypeId(attorneyTypeId: number): void {
    this.oldWekalaModel.AttorneyTypeId = attorneyTypeId;
  }
  @Mutation
  public setOtpVerification(otpVerification: OtpVerification): void {
    this.oldWekalaModel.OtpVerification = otpVerification;
  }


  @Mutation
  public setPartySefa(partySefa: PartySefa): void {
    this.partySefa = partySefa;
  }

  @Mutation
  public setFirstPartySefa(partySefa: PartySefa): void {
    this.oldWekalaModel.FirstPartyList[0].PartySefa = partySefa;
  }

  @Mutation
  public setBemogabWekalaClauses(clauses: ClausesResponse): void {
    this.bemogabwekalaClauses = clauses;
  }

  @Mutation
  public setFingurePrintReferenceMUT(referenceObj: setFingurePrintReference) {
    let index = this.oldWekalaModel.FirstPartyList.findIndex(
      (cls) => cls.PartyPerson.IdentityNo === referenceObj.IdentityNo && cls.PartyPerson.IdentityTypeId == referenceObj.IdentityType
    );

    if (index > -1) {
      this.oldWekalaModel.FirstPartyList[index].IdentificationInfo = {
        OptionId: 1,
        Reference: referenceObj.Reference,
        DateTime: referenceObj.DateTime,
        ManualSignatureReasonId: 1
      };
    }
  }




  // @Action
  // public setAqariVerfiedAction(model: SetAqariVerfiedModel): void {
  //   this.context.commit('setAqariVerfiedMut', model);
  // }

  @Action
  public setSuccessAttorneyCodeAction(code: string): void {
    this.context.commit('setSuccessAttorneyCodeMut', code);
  }

  @Action
  public setbemogabwekalaFirstParty(clause: FirstParty[]): void {
    this.context.commit('setbemogabwekalaFirstPartyMut', clause);
  }

  @Action
  public setbemogabwekalaSecondParty(secondParties: SecondParty[]): void {
    this.context.commit('setbemogabwekalaSecondPartyMut', secondParties);
  }



  @Action
  public OriginalBemogabWekalaFlatenClauses(clause: ClauseResponse[]): void {
    this.context.commit('OriginalBemogabWekalaFlatenClausesMut', clause);
  }





  @Action
  public updateMowkel(mowkel: FirstPartyList[]): void {
    this.context.commit('setMowkel', mowkel);
  }

  @Action
  public AddMowkelAction(mowkel: FirstPartyList): void {
    this.context.commit('AddMowkelMut', mowkel);
  }

  @Action
  public removeFirstPartyAction(mowkel: FirstPartyList): void {
    this.context.commit('removeMowkelMut', mowkel);
  }

  @Action
  public clearWekalaAction(): void {
    this.context.commit('clearWekala');
  }

  @Action
  public updateWakeelList(WakeelList: SecondPartyList[]): void {
    this.context.commit('setWakeelList', WakeelList);
  }
  @Action
  public updateIsGrouped(isGrouped: boolean): void {
    this.context.commit('setIsGrouped', isGrouped);
  }

  @Action
  public updateClauses(clauses: TextsValuesList[]): void {
    this.context.commit('setClauses', clauses);
  }
  @Action
  public updateLoginUserSocialID(loginUserSocialID: string): void {
    this.context.commit('setLoginUserSocialID', loginUserSocialID);
  }
  @Action
  public updateOperationType(operationType: number): void {
    this.context.commit('setOperationType', operationType);
  }
  @Action
  public updateAttorneyTypeId(attorneyTypeId: number): void {
    this.context.commit('setAttorneyTypeId', attorneyTypeId);
  }
  @Action
  public updateOtpVerification(otpVerification: OtpVerification): void {
    this.context.commit('setOtpVerification', otpVerification);
  }
  @Action
  public updateSelectedGroups(groups: ClausesGroup[]): void {
    this.context.commit('setSelectedGroupsMut', groups);
  }
  @Action
  public updatePartySefa(partySefa: PartySefa): void {
    this.context.commit('setPartySefa', partySefa);
  }
  @Action
  public updateFirstPartySefa(partySefa: PartySefa): void {
    this.context.commit('setFirstPartySefa', partySefa);
  }

  @Action
  public updateBemogabWekalaClauses(clauses: ClausesResponse): void {
    this.context.commit('setBemogabWekalaClauses', clauses);
  }

  @Action
  public AddPreSelectedClausesList(list: ClauseResponse[]): void {
    // debugger;
    this.context.commit('AddPreSelectedClausesListMut', list);
  }

  @Action
  public SetFingurePrintReference(referenceObj: setFingurePrintReference) {
    this.context.commit('setFingurePrintReferenceMUT', referenceObj);
  }


  ///user store
}
// export default UserStore;
